import React, {useEffect} from 'react';
import './portfolio.css'
// import Swiper core and required modules
import {Autoplay, Navigation, Pagination, Keyboard, A11y} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {sketchProjectData} from '../../Data'

import Aos from "aos";
import 'aos/dist/aos.css'

const Portfolio = ({observer, sectionRef}) => {
    useEffect(() => {
        Aos.init({duration: 1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    return (
        <section id='portfolio' className='portfolio' ref={sectionRef}>
            <div data-aos='fade-up' data-aos-duration='2000' className='portfolio_header'>
                <h2 className="eyebrow">Selected work · 2022—2026</h2>
                <h1>Interior & architectural sketches</h1>
                <p>A selection of interior, exterior and spatial studies—drawn to communicate material, proportion and mood at a glance.</p>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container portfolio_container'>
                <div className='portfolio_item'>
                    <Swiper modules={[Autoplay, Navigation, Pagination, Keyboard, A11y]}
                            spaceBetween={20}
                            slidesPerView={1}
                            loop
                            keyboard={{enabled: true}}
                            a11y={{enabled: true}}
                            pagination={{clickable: true}}
                            navigation={true}
                            autoplay={{
                                delay: 6000,
                                disableOnInteraction: false,
                                // pauseOnMouseEnter: true,
                            }}
                            style={{
                                "--swiper-navigation-color": "var(--ink)",
                                "--swiper-pagination-color": "var(--clay)",
                            }}
                    >
                        {
                            sketchProjectData.map((project, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <figure className="project_figure">
                                            <img className="project_design_img"
                                                 src={project.designImg}
                                                 alt={project.projectName || "Sketch"}
                                                 loading="lazy"
                                                 decoding="async"
                                                 draggable="false"
                                            />
                                            {project.projectName && (
                                                <figcaption className="design_description"><span>{String(index + 1).padStart(2, '0')}</span>{project.projectName}<span>Selected work</span></figcaption>
                                            )}
                                        </figure>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
